(function (root) {
  'use strict';
  const setId = '41656117428342';
  const components = ['41656117461110', '41656117493878', '41656117526646', '41656117559414'];
  const validQuantity = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 && Number(value) <= 999;
  function count(stock, id) {
    return String(id) === setId ? Math.min(...components.map(child => Math.max(0, stock[child] || 0))) : Math.max(0, stock[id] || 0);
  }
  function allocate(stock, lines) {
    const remaining = {...stock};
    const allocations = lines.map(line => {
      if (!validQuantity(line.quantity)) throw new Error('Invalid quantity');
      const quantity = Number(line.quantity);
      const gallery = Math.min(quantity, count(remaining, line.id));
      const consumed = String(line.id) === setId ? components : [String(line.id)];
      consumed.forEach(id => { remaining[id] = Math.max(0, (remaining[id] || 0) - gallery); });
      return {...line, quantity, gallery, order: quantity - gallery};
    });
    return {remaining, allocations};
  }
  function largest(variants) {
    return [...variants].sort((a, b) => {
      const size = v => Number((v.title.match(/(\d+(?:\.\d+)?)\s*["”]/) || [0, 0])[1]);
      return size(b) - size(a);
    })[0];
  }
  const api = { setId, components, count, allocate, largest, validQuantity};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.GaryPriceStock = api;
})(typeof window === 'undefined' ? this : window);
